var _path, _circle, _line, _line2, _path2, _circle2, _line3, _line4, _path3, _circle3, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.93,27.582v-9.221c0-1.407-1.141-2.548-2.548-2.548h-6.733c-1.407,0-2.548,1.141-2.548,2.548v9.221"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.016,
    cy: 9.04,
    r: 3.226
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.67,
    y1: 36.185,
    x2: 18.67,
    y2: 21.335
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.387,
    y1: 21.335,
    x2: 23.387,
    y2: 36.185
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.759,27.498v-5.911c0-1.407-1.141-2.548-2.548-2.548h-6.733c-1.407,0-2.548,1.141-2.548,2.548v5.911"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.844,
    cy: 12.266,
    r: 3.226
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30.498,
    y1: 33.662,
    x2: 30.498,
    y2: 24.561
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35.215,
    y1: 24.561,
    x2: 35.215,
    y2: 33.662
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3.241,27.498v-5.911c0-1.407,1.141-2.548,2.548-2.548h6.733c1.407,0,2.548,1.141,2.548,2.548v5.911"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.156,
    cy: 12.266,
    r: 3.226
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11.502,
    y1: 33.662,
    x2: 11.502,
    y2: 24.561
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.785,
    y1: 24.561,
    x2: 6.785,
    y2: 33.662
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorMeeting);
export default __webpack_public_path__ + "static/media/indoor-meeting.224660f22439236feefd529655284074.svg";
export { ForwardRef as ReactComponent };